/**
 * Created by work on 17/1/10.
 */
export const REFRESH_REPORT = 'REFRESH_REPORT';
export const REFRESH_TAB = 'REFRESH_TAB';

export const refreshReport = (reportData) => ({
  type: REFRESH_REPORT,
  reportData
});

export const refreshTab = (tabIndex) => ({
  type: REFRESH_TAB,
  tabIndex
});



// WEBPACK FOOTER //
// ./src/actions/report.js